import { createStore, applyMiddleware, compose } from "redux";
import { thunk as thunkMiddleware } from "redux-thunk";
import rootReducer from "./reducers";
import reduxImmutableStateInvariant from "redux-immutable-state-invariant";
// import thunk from "redux-thunk";

export default function configureStore(initialState) {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION__COMPOSE__ || compose; // Adds support for Redux dev tools

  const middleware = [thunkMiddleware, reduxImmutableStateInvariant()];

  return createStore(
    rootReducer,
    initialState,
    // composeEnhancers(applyMiddleware(thunk, reduxImmutableStateInvariant()))
     composeEnhancers(applyMiddleware(...middleware))
  );
}
